// extracted by mini-css-extract-plugin
export var container = "StockTakes-module--container--nH6CS";
export var content = "StockTakes-module--content--HaK1Z";
export var noOrders = "StockTakes-module--noOrders--jXuo7";
export var subHeader = "StockTakes-module--subHeader--5ktr+";